<template>
    <div class="foodPackStock">
      <iframe scrolling: no
        :src="src"
        frameborder="0"
      ></iframe>
    </div>
  </template>
  
  <script>
  import urls from "../../utils/baseUrl2";
  
  export default {
    name: "foodPackStock",
    props: {
      id: {
        type: [Number, String],
        required: true,
      },
    },
    data() {
      return {
        src: `${urls.baseUrl}foodPackStock/roomPriceIframe.html?packId=${this.id}&isDevelopment=${urls.baseUrl}`,
      };
    },
    mounted() {},
    created() {
      console.log(this.id,'++++++');
    },
    methods: {},
  };
  </script>
  <style scoped lang='less'>
  .foodPackStock {
    height: 860px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  </style>